<div class="header" (clickOutside)="selectedMenu = ''">
  <div class="logo"></div>
  <div class="controls">
    <div class="time-controls d-flex align-items-center">
      <span class="time">
        <span class="hour">{{ hour < 10 ? ('0' + hour) : hour }}</span>
        <span class="separate" [ngStyle]="{ 'opacity': colon ? 1 : 0 }">:</span>
        <span class="minute">{{ minute < 10 ? ('0' + minute) : minute }}</span>
      </span>
      <span class="time-zone">({{clientTimezone}})</span>
    </div>
    <div class="notification" [class.selected]="selectedMenu === 'notification'"
      (click)="onClickNotification(); selectMenu('notification')">
      <div class="new-notification" *ngIf="notificationService?.counterUnread > 0">{{notificationService.counterUnread}}</div>
    </div>
    <app-avatar-upload class="user" [imageSrc]="userProfile?.avatar" [edit]="false" [configs]="{isActive: selectedMenu === 'user'}" (click)="selectMenu('user')"></app-avatar-upload>
  </div>
  <div class="menu">
    <div class="notification scrollbar-custom" *ngIf="selectedMenu === 'notification'">
      <div class="heading">{{'Notifications' | translate}}</div>
      <app-notification [notifications]="notificationService?.notifications"></app-notification>
    </div>
    <div class="user-menu" *ngIf="selectedMenu === 'user'">
      <div class="info">
        <div class="heading">{{'My Profile' | translate}}</div>
        <div class="name">{{ userProfile?.name }}
          <div class="role">{{ userProfile?.role.name }}</div>
        </div>
        <div class="name">{{ userProfile?.company.name }}</div>
      </div>
      <mat-divider></mat-divider>
      <div class="actions">
        <a class="action" [routerLink]="['/account/profile']" fragment="my-profile">
          {{'My Account' | translate}}
        </a>
        <a class="action" [routerLink]="['/account/profile']" fragment="profile-management">
          {{'Profile Management' | translate}}
        </a>
        <a class="action" [routerLink]="['/account/profile']" fragment="history">
          {{'History' | translate}}
        </a>
      </div>
      <mat-divider></mat-divider>
      <div class="actions">
        <a (click)="logout()" class="action logout">
          {{'Logout' | translate}}
          <span *ngIf="showSpinnerLogout" class="spinner-border spinner-border-sm"></span>
        </a>
      </div>
    </div>
  </div>
</div>
